module.exports = __webpack_public_path__ + "static/media/Graphics.02bea1fe.gif";